export default "__VITE_ASSET__DXmS_Dxx__"